export function getBreadcrumbsItemsKey(items) {
  return items?.map(item => `${item.id}:${item.title}`).join()
}

export function getListItemProps(current, last) {
  return {
    active: current === last,
    checked: current === 1,
    head: current === 0,
    key: current,
  }
}
